import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'PACKAGE_UPDATE',
    smsDelete : 'PACKAGE_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        package: [],

        submitSuccess: false,
        packageLoading: false,
        packageError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_PACKAGE(state, items) {
            state.package = items;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        PACKAGE_LOADING (state, loading) {
            state.packageLoading = loading;
        },

        PACKAGE_ERROR (state, hasError) {
            state.packageError = hasError;
        }
    },

    actions: {
        async addPackage ({commit, dispatch}, payload) {
            commit('PACKAGE_LOADING', true);
            commit('PACKAGE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try {
                let response = await axios.post(V1API.create_package, payload.package, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPackage')
                return response

            } catch (e) {
                commit('PACKAGE_ERROR', true);
            } finally {
                commit('PACKAGE_LOADING', false);
            }
        },

        async fetchPackage ({ commit }) {
            commit('PACKAGE_LOADING', true);
            commit('PACKAGE_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.package_list, config);
                let response = result.data
                commit('SET_PACKAGE', response.data);

            } catch(error) {
                commit('PACKAGE_ERROR', true);
            } finally {
                commit('PACKAGE_LOADING', false);
            }
        },

        async updatePackage ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_package + payload.id, payload.package, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPackage')
                return response

            } catch (e) {
                commit('PACKAGE_ERROR', true);
            } finally {
                commit('PACKAGE_LOADING', false);
            }
        },
        
        async deletePackage({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.package_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchPackage')
            return response
        }
    },

    getters: {}
}
